export default __webpack_public_path__ + "static/media/epicentr.75cd4519.svg";